import { FabricationJobState } from '../../api/fabrication-job-api';
import { html } from 'lit';
import { LangFabricationJobDetailView } from '../../../localization/scripts/fabrication-jobs/views/fabrication-job-detail-view-lang';

export function getFabricationJobStateLabel(state: FabricationJobState): string {
  switch (state) {
    case FabricationJobState.Draft:
      return LangFabricationJobDetailView.stateDraft();
    case FabricationJobState.Planned:
      return LangFabricationJobDetailView.statePlanned();
    case FabricationJobState.AwaitingOrder:
      return LangFabricationJobDetailView.stateAwaitingOrder();
    case FabricationJobState.ReadyForProduction:
      return LangFabricationJobDetailView.stateReadyForProduction();
    case FabricationJobState.InProduction:
      return LangFabricationJobDetailView.stateInProduction();
    case FabricationJobState.Completed:
      return LangFabricationJobDetailView.stateCompleted();
    default:
      return '';
  }
}

function getFabricationJobStateCssName(state: FabricationJobState): string {
  switch (state) {
    case FabricationJobState.Draft:
      return 'draft';
    case FabricationJobState.Planned:
      return 'planned';
    case FabricationJobState.AwaitingOrder:
      return 'awaitingorder';
    case FabricationJobState.ReadyForProduction:
      return 'readyforproduction';
    case FabricationJobState.InProduction:
      return 'inproduction';
    case FabricationJobState.Completed:
      return 'completed';
    default:
      return '';
  }
}

export const getFabricationJobStatus = (state: FabricationJobState, asBadge = false) => {
  if (!asBadge) return html`${getFabricationJobStateLabel(state)}`;

  const value = getFabricationJobStateCssName(state);
  const text = getFabricationJobStateLabel(state);

  return html`<span class="badge badge-${value}">${text}</span>`;
};
